import type { Routes, UrlMatchResult, UrlSegment } from '@angular/router';

import { urlMatcher } from '#shell/utils/url-matcher';

enum WheelOfFortuneRoute {
    WHEEL_OF_FORTUNE = 'wheel-of-fortune',
    GET_MY_GIFT = 'get-my-gift',
    WHEEL_OF_FORTUNE_RULES = 'wheel-of-fortune-rules',
    WHEEL_OF_FORTUNE_REDIRECT = 'wheel-of-fortune-redirect',
    WHEEL_OF_FORTUNE_MESSAGES = 'wheel-of-fortune-messages',
    WHEEL_OF_FORTUNE_NOT_FOUND = 'wheel-of-fortune-not-found',
}

export function wheelOfFortuneMatcher(segments: UrlSegment[]): UrlMatchResult | null {
    return urlMatcher(segments, WheelOfFortuneRoute);
}

export const LOGGED_OUT_WHEELS_OF_FORTUNE_ROUTES: Routes = [
    {
        path: WheelOfFortuneRoute.WHEEL_OF_FORTUNE,
        loadComponent: () =>
            import('#modules/wheels-of-fortune/views/logged-out/play-wheel-of-fortune/play-wheel-of-fortune-root.component').then(
                (m) => m.PlayWheelOfFortuneRootComponent
            ),
    },
    {
        path: `${WheelOfFortuneRoute.GET_MY_GIFT}/:gift_draw_id`,
        loadComponent: () =>
            import('#modules/wheels-of-fortune/views/logged-out/get-my-gift/get-my-gift.component').then((m) => m.GetMyGiftComponent),
    },
    {
        path: WheelOfFortuneRoute.WHEEL_OF_FORTUNE_RULES,
        loadComponent: () =>
            import('#modules/wheels-of-fortune/views/logged-out/wheel-of-fortune-rules/wheel-of-fortune-rules.component').then(
                (m) => m.WheelOfFortuneRulesComponent
            ),
    },
    {
        path: WheelOfFortuneRoute.WHEEL_OF_FORTUNE_REDIRECT,
        loadComponent: () =>
            import('#modules/wheels-of-fortune/views/logged-out/wheel-of-fortune-redirect/wheel-of-fortune-redirect.component').then(
                (m) => m.WheelOfFortuneRedirectComponent
            ),
    },
    {
        path: WheelOfFortuneRoute.WHEEL_OF_FORTUNE_MESSAGES,
        loadComponent: () =>
            import('#modules/wheels-of-fortune/views/logged-out/wheel-of-fortune-messages/wheel-of-fortune-messages.component').then(
                (m) => m.WheelOfFortuneMessagesComponent
            ),
    },
    {
        path: WheelOfFortuneRoute.WHEEL_OF_FORTUNE_NOT_FOUND,
        loadComponent: () =>
            import('#modules/wheels-of-fortune/views/logged-out/wheel-of-fortune-not-found/wheel-of-fortune-not-found.component').then(
                (m) => m.WheelOfFortuneNotFoundComponent
            ),
    },
];
